import validators from '../../utils/validators';

class DrugPackage {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      count: (v) => validators.isNumber(v),
      weight: (v) => validators.isNumberOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugPackage property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default DrugPackage;
